export const cacheKey = "/engagement/canvas/:app_group_id/eligible" as const;
